"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _EnvIndicator = _interopRequireDefault(require("../../elements/env/EnvIndicator"));
var _MobileView = _interopRequireDefault(require("../../elements/view/MobileView"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var EnvHolder = _styledComponents["default"].div.attrs(function () {
  return {
    className: "fixed-top"
  };
}).withConfig({
  displayName: "NavBar__EnvHolder",
  componentId: "jqij3h-0"
})(["width:100%;"]);
var NavBar = function NavBar(_ref) {
  var children = _ref.children,
    displayEnvIndicator = _ref.displayEnvIndicator,
    vertical = _ref.vertical,
    env = _ref.env;
  var getComponent = function getComponent(displayName) {
    return children.filter(function (comp) {
      return comp.props.displayName === displayName;
    });
  };
  return _react["default"].createElement("div", {
    id: "best-navbar"
  }, displayEnvIndicator ? _react["default"].createElement(_MobileView["default"], null, _react["default"].createElement(EnvHolder, null, _react["default"].createElement(_EnvIndicator["default"], {
    env: env
  }))) : null, getComponent("nav-bar-signout"), vertical ? getComponent("navigation-vertical") : getComponent("navigation"));
};
NavBar.propTypes = {
  displayEnvIndicator: _propTypes["default"].bool,
  vertical: _propTypes["default"].bool,
  env: _propTypes["default"].string,
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]).isRequired
};
NavBar.defaultProps = {
  displayEnvIndicator: false,
  vertical: false,
  env: "dev"
};
var _default = NavBar;
exports["default"] = _default;